/** @jsx jsx */
import { jsx, Container } from "theme-ui";
import { Themed } from "@theme-ui/mdx";
import { Link as GatsbyLink } from "gatsby";

import Layout from "../components/Layout";
import PageSection from "../components/PageSection";
import PageSectionHeading from "../components/PageSectionHeading";

const NotFoundPage = () => {
  return (
    <Layout title="404">
      <PageSection>
        <Container sx={{display: "flex", flexDirection: "column", alignItems: "center"}}>
          <PageSectionHeading title="404" />
          <Themed.p>This page does not seem to exist.</Themed.p>
          <Themed.p>
            <GatsbyLink to="/" sx={{variant: "links.inline"}}>
              Take me back
            </GatsbyLink>
          </Themed.p>
        </Container>
      </PageSection>
    </Layout>
  );
};

export default NotFoundPage;
